<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="420px"
    >
        <v-card>
            <v-container class="my-2">
                <v-card-title class="text-md-h6 text-center text-break mb-3 font-weight-bold">
                    {{ $t('indicators.messages.edit_indicator_question', {reportTitle: bible.title}) }}
                </v-card-title>
                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}</v-btn>

                    <v-btn
                        class="v-btn--primary"
                        text
                        @click="confirmEdit"
                        :disabled="editingBible"
                    >{{ $t('app.edit') }}</v-btn>

                    <v-progress-circular
                        indeterminate
                        class="mt-2 ml-2"
                        v-if="this.editingBible && !this.cancelEdit"
                        color="grey"
                        size="16"
                    ></v-progress-circular>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import {EventBus} from "@/event-bus";

export default {
    name: "EditBibleDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        bible: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            editingBible: false,
            cancelEdit: false,
        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmEdit() {
            this.editingBible = this.bible;
            this.$emit('confirmBibleEdition')
        },

        /**
         * Closes the edition dialog
         */
        closeDialog() {
            this.cancelEdit = true;
            if (this.cancelEdit) {
                this.$emit('cancelBibleEdition')
                this.cancelEdit = false;
                this.editingBible = false; // Fuerza el cambio
            }

        },

        /**
         * Hides spinner after edit bible succeed
         */
        stopBibleEditingSpinner() {
            this.editingBible = false
        }
    },

    /*created() {
        EventBus.$on('reports.management.delete-report', this.stopBibleEditingSpinner)
    }*/
}
</script>

<style scoped>

</style>
